import React, { useEffect, useState } from "react";
import ScrollToTop from "react-scroll-to-top";
import { useTheme } from '@mui/material/styles';
import {
  Button,
  Container,
  Grid,
  Typography,
  Modal,
  Box,
  Stack,
  Divider,
  TextField,
  CardHeader,
} from "@mui/material";
import { toast } from 'react-toastify';
import { makeStyles } from '@material-ui/styles';
import SwipeableViews from 'react-swipeable-views';

import { useDispatch, useSelector } from "react-redux";
import OnboardPreview from "./OnboardPreview";
import AntSwitch from "../../components/layout/AntSwitch";
import ToastMessage from "../../components/layout/ToastMessage";
import WelcomeOnboardModal from "../../components/layout/WelcomeOnboardModal";
import ConfirmModal from '../../components/layout/ConfirmModal';
import { customizeOnboardForm, getBookingFormData, sendWelcomePackMail } from "../../redux/actions/book";
import { resizeWelcomePackImage } from "../../utils/resizeFile";
import IMG_GRADIENT1 from "../../assets/img/gradient-01.png";
import IMG_GRADIENT2 from "../../assets/img/gradient-02.png";
import IMG_GRADIENT3 from "../../assets/img/gradient-03.png";
import IMG_TEMPLATE_THUMB_1 from "../../assets/img/template-thumb-01.jpg";
import IMG_TEMPLATE_THUMB_2 from "../../assets/img/template-thumb-02.jpg";
import IMG_TEMPLATE_THUMB_3 from "../../assets/img/template-thumb-03.jpg";
import config from "../../config/config";
import "./OnboardFormPage.style.css";

const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
const MAX_FILE_SIZE = 5000000;

const THUMBS = [
  {
    img: IMG_TEMPLATE_THUMB_1,
    label: 'thumb_1',
  },
  {
    img: IMG_TEMPLATE_THUMB_2,
    label: 'thumb_2',
  },
  {
    img: IMG_TEMPLATE_THUMB_3,
    label: 'thumb_3',
  },
];

const OnboardFormPage = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(state => ({
    user: state.auth.user
  }));
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [showWelcomeOnboardModal, setShowWelcomeOnboardModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const onCloseWelcomeOnboardModal = () => setShowWelcomeOnboardModal(false);

  const useStyles = makeStyles({
    avatar: {
      cursor: 'pointer',
    },
    title: {
      cursor: 'pointer',
      color: theme.palette.mode === 'light' ? '#181c32' : '#fff',
      fontSize: '1rem !important',
      fontWeight: '600 !important',
    },
    subheader: {
      cursor: 'pointer',
      color: theme.palette.mode === 'light' ? '#181c32' : '#6d6d80',
      fontSize: '0.7rem !important',
      fontWeight: 400,
    }
  });
  const classes = useStyles(theme);

  useEffect(() => {
    dispatch(getBookingFormData(user?.bookFormId));
    const imgTemplateThumbList = [IMG_TEMPLATE_THUMB_1, IMG_TEMPLATE_THUMB_2, IMG_TEMPLATE_THUMB_3];
    imgTemplateThumbList.forEach((image) => {
      new Image().src = image
    });
  }, []);

  useEffect(() => {
    if (user?.id) {
      const dontShow = localStorage.getItem(user?.id + "_DONT_SHOW_WELCOME_ONBOARD_TIP") || "false";
      if (dontShow === 'false') {
        setShowWelcomeOnboardModal(true);
      }
    }
  }, [user]);

  const emailNotification = useSelector(state => state.book.emailNotification);

  const [onboardHeadingTitle, setOnboardHeadingTitle] = useState('');
  const [onboardHeadingMessage, setOnboardHeadingMessage] = useState('');
  const [onboardHeadingEnableDate, setOnboardHeadingEnableDate] = useState(true);
  const [onboardSection1Enable, setOnboardSection1Enable] = useState(true);
  const [onboardSection1Image, setOnboardSection1Image] = useState(null);
  const [onboardSection1ImageSelected, setOnboardSection1ImageSelected] = useState(null);
  const [onboardSection1Heading, setOnboardSection1Heading] = useState('');
  const [onboardSection1Content, setOnboardSection1Content] = useState('');
  const [onboardSection2Enable, setOnboardSection2Enable] = useState(true);
  const [onboardSection2Image, setOnboardSection2Image] = useState(null);
  const [onboardSection2ImageSelected, setOnboardSection2ImageSelected] = useState(null);
  const [onboardSection2Heading, setOnboardSection2Heading] = useState('');
  const [onboardSection2Content, setOnboardSection2Content] = useState('');
  const [onboardSection3Enable, setOnboardSection3Enable] = useState(true);
  const [onboardSection3Image, setOnboardSection3Image] = useState(null);
  const [onboardSection3ImageSelected, setOnboardSection3ImageSelected] = useState(null);
  const [onboardSection3Heading, setOnboardSection3Heading] = useState('');
  const [onboardSection3Content, setOnboardSection3Content] = useState('');
  const [onboardFooterHeading, setOnboardFooterHeading] = useState('');
  const [onboardFooterContent, setOnboardFooterContent] = useState('');
  const [onboardTemplate, setOnboardTemplate] = useState(0);

  useEffect(() => {
    if(emailNotification.onboardHeadingTitle) {
      setOnboardHeadingTitle(emailNotification.onboardHeadingTitle);
      setOnboardHeadingMessage(emailNotification.onboardHeadingMessage);
      setOnboardHeadingEnableDate(emailNotification.onboardHeadingEnableDate);
      setOnboardSection1Enable(emailNotification.onboardSection1Enable);
      setOnboardSection1Image(emailNotification.onboardSection1Image);
      setOnboardSection1Heading(emailNotification.onboardSection1Heading);
      setOnboardSection1Content(emailNotification.onboardSection1Content);
      setOnboardSection2Enable(emailNotification.onboardSection2Enable);
      setOnboardSection2Image(emailNotification.onboardSection2Image);
      setOnboardSection2Heading(emailNotification.onboardSection2Heading);
      setOnboardSection2Content(emailNotification.onboardSection2Content);
      setOnboardSection3Enable(emailNotification.onboardSection3Enable);
      setOnboardSection3Image(emailNotification.onboardSection3Image);
      setOnboardSection3Heading(emailNotification.onboardSection3Heading);
      setOnboardSection3Content(emailNotification.onboardSection3Content);
      setOnboardFooterHeading(emailNotification.onboardFooterHeading);
      setOnboardFooterContent(emailNotification.onboardFooterContent);
      setOnboardTemplate(emailNotification.onboardTemplate);
    }
  }, [emailNotification]);

  const handleOpen = () => {
    setShowConfirmModal(true);
  }

  const handleOnboardHeadingEnableDateChange = (event) => {
    setOnboardHeadingEnableDate(event.target.checked);
  };

  const handleOnboardSection1Enable = event => setOnboardSection1Enable(event.target.checked);
  const handleOnboardSection1ImageUpload = () => {
    document.querySelector('#Section1-Image-Selection').value = null;
    document.querySelector('#Section1-Image-Selection').click();
  }
  const handleOnboardSection1ImageRemove = () => {
    setOnboardSection1Image(null);
  }
  const handleOnboardSection1SelectImage = async e => {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    if (!ACCEPTED_IMAGE_TYPES.includes(files?.[0]?.type)) {
      return;
    }
    if (files[0].size > MAX_FILE_SIZE) {
      return;
    }
    const file = files[0];
    const resizedFile = await resizeWelcomePackImage(file, file.type.split('/').pop().toUpperCase());
    setOnboardSection1Image(resizedFile);
    const reader = new FileReader();
    reader.readAsDataURL(resizedFile);
    reader.onloadend = (e) => {
      setOnboardSection1ImageSelected(reader.result);
    };
  }

  const handleOnboardSection2Enable = event => setOnboardSection2Enable(event.target.checked);
  const handleOnboardSection2ImageUpload = () => {
    document.querySelector('#Section2-Image-Selection').value = null;
    document.querySelector('#Section2-Image-Selection').click();
  }
  const handleOnboardSection2ImageRemove = () => {
    setOnboardSection2Image(null);
  }
  const handleOnboardSection2SelectImage = async  e => {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    if (!ACCEPTED_IMAGE_TYPES.includes(files?.[0]?.type)) {
      return;
    }
    if (files[0].size > MAX_FILE_SIZE) {
      return;
    }
    const file = files[0];
    const resizedFile = await resizeWelcomePackImage(file, file.type.split('/').pop().toUpperCase());
    setOnboardSection2Image(resizedFile);
    const reader = new FileReader();
    reader.readAsDataURL(resizedFile);
    reader.onloadend = (e) => {
      setOnboardSection2ImageSelected(reader.result);
    };
  }

  const handleOnboardSection3Enable = event => setOnboardSection3Enable(event.target.checked);
  const handleOnboardSection3ImageUpload = () => {
    document.querySelector('#Section3-Image-Selection').value = null;
    document.querySelector('#Section3-Image-Selection').click();
  }
  const handleOnboardSection3ImageRemove = () => {
    setOnboardSection3Image(null);
  }
  const handleOnboardSection3SelectImage = async e => {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    if (!ACCEPTED_IMAGE_TYPES.includes(files?.[0]?.type)) {
      return;
    }
    if (files[0].size > MAX_FILE_SIZE) {
      return;
    }
    const file = files[0];
    const resizedFile = await resizeWelcomePackImage(file, file.type.split('/').pop().toUpperCase());
    setOnboardSection3Image(resizedFile);
    const reader = new FileReader();
    reader.readAsDataURL(resizedFile);
    reader.onloadend = (e) => {
      setOnboardSection3ImageSelected(reader.result);
    };
  }

  const handleClose = () => setOpen(false);
  const onCloseConfirmModal = () => setShowConfirmModal(false);

  const onLivePreview = () => {
    setPreviewModalVisible(true);
  }

  const onSendToSelf = async () => {
    const res = await dispatch(sendWelcomePackMail({ isTest: true }));
    if (res.success) {
      toast(<ToastMessage title="Welcome Pack Sent" message="A Welcome Pack preview has been sent to your email." />, {closeButton: false});
    } else {
      toast(<ToastMessage title="Error" message="We're sorry but something went wrong." />, {closeButton: false});
    }
  }

  const onConfirmYes = async () => {
    onCloseConfirmModal();
    
    let formData = new FormData();
    formData.append('bookFormId', emailNotification.bookFormId);
    formData.append('onboardHeadingTitle', onboardHeadingTitle);
    formData.append('onboardHeadingMessage', onboardHeadingMessage);
    formData.append('onboardHeadingEnableDate', onboardHeadingEnableDate);
    formData.append('onboardSection1Enable', onboardSection1Enable);
    formData.append('onboardSection1Image', onboardSection1Image);
    formData.append('onboardSection1Heading', onboardSection1Heading);
    formData.append('onboardSection1Content', onboardSection1Content);
    formData.append('onboardSection2Enable', onboardSection2Enable);
    formData.append('onboardSection2Image', onboardSection2Image);
    formData.append('onboardSection2Heading', onboardSection2Heading);
    formData.append('onboardSection2Content', onboardSection2Content);
    formData.append('onboardSection3Enable', onboardSection3Enable);
    formData.append('onboardSection3Image', onboardSection3Image);
    formData.append('onboardSection3Heading', onboardSection3Heading);
    formData.append('onboardSection3Content', onboardSection3Content);
    formData.append('onboardFooterHeading', onboardFooterHeading);
    formData.append('onboardFooterContent', onboardFooterContent);
    formData.append('onboardTemplate', onboardTemplate);
    await dispatch(customizeOnboardForm(formData));
    setOpen(true);
  }

  const renderSection1 = () => {
    return (
      <Container
        direction='column'
        sx={{ backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d', px: '40px !important' }}
      >
        <Grid>
          <Typography sx={{ fontWeight: 700, fontSize: '1.2rem', color: theme.palette.mode === 'light' ? '#3f4254' : '#fff' }}>Section 1: Before Our Date</Typography>
          <Typography sx={{ fontSize: '11px', mt: 0.5, color: '#a1a5b7', fontWeight: 400 }}>
            Suggested content: Things to know and prepare before our date, communication etiquette, gift ideas, cancellation policy, etc
          </Typography>
        </Grid>
        <Divider sx={{ mt: 2 }} />
        <Grid container alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Enable This Section?</Typography>
          </Grid>
          <Grid item xs>
            <AntSwitch
              checked={onboardSection1Enable}
              onChange={handleOnboardSection1Enable}
              inputProps={{ 'aria-label': 'ant design' }}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={12} md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Image Upload</Typography>
          </Grid>
          <Grid item xs>
            <Box display="inline-flex" borderRadius="6px" position="relative" sx={{ boxShadow: 3 }}>
              {onboardSection1ImageSelected ?
                <Box
                  component="img"
                  src={onboardSection1ImageSelected}
                  sx={{ width: { xs: '100%', md: '350px' }, border: '3px solid white', borderRadius: '6px', mt: { xs: 1 } }}
                  alt="section1ImageSelected"
                /> :
                <Box
                  component="img"
                  src={`${config.SERVER_BASE_URL}/${onboardSection1Image}`}
                  sx={{ width: { xs: '100%', md: '350px' }, border: '3px solid white', borderRadius: '6px', mt: { xs: 1 } }}
                  alt="placeholder_image"
                />
              }
              <span className="Image-upload" onClick={handleOnboardSection1ImageUpload}>
                <i className="fa fa-pen"></i>
              </span>
              <span className="Image-remove" onClick={handleOnboardSection1ImageRemove}>
                <i className="fa fa-remove"></i>
              </span>
            </Box>
            <Typography sx={{ fontSize: '0.7rem', mt: 0.5, color: '#a1a5b7', fontWeight: 500 }}>
              Recommended size 640x360px. Allowed file types: jpg, png
            </Typography>
            <input type="file" name="idCard" id="Section1-Image-Selection" style={{ visibility: 'hidden' }} disabled={!onboardSection1Enable} onChange={handleOnboardSection1SelectImage} />
          </Grid>
        </Grid>
        <Grid container alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs={12} md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Section Heading</Typography>
          </Grid>
          <Grid item xs>
            <TextField
              variant="standard"
              fullWidth
              sx={{ mt: { xs: 1, md: 0 } }}
              value={onboardSection1Heading}
              onChange={e => setOnboardSection1Heading(e.target.value)}
              disabled={!onboardSection1Enable}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '8px 20px',
                  borderRadius: '6px',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                }
              }}
            />
          </Grid>
        </Grid>
        <Grid container alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs={12} md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Section Content</Typography>
          </Grid>
          <Grid item xs>
            <TextField
              variant="standard"
              fullWidth
              sx={{ mt: { xs: 1, md: 0 } }}
              multiline
              rows={8}
              value={onboardSection1Content}
              onChange={e => setOnboardSection1Content(e.target.value)}
              disabled={!onboardSection1Enable}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '15px 20px',
                  borderRadius: '6px',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                }
              }}
            />
          </Grid>
        </Grid>
      </Container>
    );
  };

  const renderSection2 = () => {
    return (
      <Container
        direction='column'
        sx={{ backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d', padding: '32px !important' }}
      >
        <Grid>
          <Typography sx={{ fontWeight: 700, fontSize: '1.2rem', color: theme.palette.mode === 'light' ? '#3f4254' : '#fff' }}>Section 2: During Our Date</Typography>
          <Typography sx={{ fontSize: '11px', mt: 0.5, color: '#a1a5b7', fontWeight: 400 }}>
            Suggested content: Handling the donation, date etiquette, date extensions, etc
          </Typography>
        </Grid>
        <Divider sx={{ mt: 2 }} />
        <Grid container alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Enable This Section?</Typography>
          </Grid>
          <Grid item xs>
            <AntSwitch
              checked={onboardSection2Enable}
              onChange={handleOnboardSection2Enable}
              inputProps={{ 'aria-label': 'ant design' }}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={12} md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Image Upload</Typography>
          </Grid>
          <Grid item xs>
            <Box display="inline-flex" borderRadius="6px" position="relative" sx={{ boxShadow: 3 }}>
              {onboardSection2ImageSelected ?
                <Box
                  component="img"
                  src={onboardSection2ImageSelected}
                  sx={{ width: { xs: '100%', md: '350px' }, border: '3px solid white', borderRadius: '6px', mt: { xs: 1 } }}
                  alt="section2ImageSelected"
                /> :
                <Box
                  component="img"
                  src={`${config.SERVER_BASE_URL}/${onboardSection2Image}`}
                  sx={{ width: { xs: '100%', md: '350px' }, border: '3px solid white', borderRadius: '6px', mt: { xs: 1 } }}
                  alt="placeholder_image"
                />
              }
              <span className="Image-upload" onClick={handleOnboardSection2ImageUpload}>
                <i className="fa fa-pen"></i>
              </span>
              <span className="Image-remove" onClick={handleOnboardSection2ImageRemove}>
                <i className="fa fa-remove"></i>
              </span>
            </Box>
            <Typography sx={{ fontSize: '0.7rem', mt: 0.5, color: '#a1a5b7', fontWeight: 500 }}>
              Recommended size 640x360px. Allowed file types: jpg, png
            </Typography>
            <input type="file" name="idCard" id="Section2-Image-Selection" style={{ visibility: 'hidden' }} disabled={!onboardSection2Enable} onChange={handleOnboardSection2SelectImage} />
          </Grid>
        </Grid>
        <Grid container alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs={12} md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Section Heading</Typography>
          </Grid>
          <Grid item xs>
            <TextField
              variant="standard"
              fullWidth
              sx={{ mt: { xs: 1, md: 0 } }}
              value={onboardSection2Heading}
              onChange={e => setOnboardSection2Heading(e.target.value)}
              disabled={!onboardSection2Enable}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '8px 20px',
                  borderRadius: '6px',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                }
              }}
            />
          </Grid>
        </Grid>
        <Grid container alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs={12} md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Section Content</Typography>
          </Grid>
          <Grid item xs>
            <TextField
              variant="standard"
              fullWidth
              sx={{ mt: { xs: 1, md: 0 } }}
              multiline
              rows={8}
              value={onboardSection2Content}
              onChange={e => setOnboardSection2Content(e.target.value)}
              disabled={!onboardSection2Enable}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '15px 20px',
                  borderRadius: '6px',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                }
              }}
            />
          </Grid>
        </Grid>
      </Container>
    );
  };

  const renderSection3 = () => {
    return (
      <Container
        direction='column'
        sx={{ backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d', padding: '32px !important' }}
      >
        <Grid>
          <Typography sx={{ fontWeight: 700, fontSize: '1.06rem', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Section 3: After Our Date</Typography>
          <Typography sx={{ fontSize: '11px', mt: 0.5, color: '#a1a5b7', fontWeight: 400 }}>
            Suggested content: Post-date etiquette, review policy, rebooking incentives, etc
          </Typography>
        </Grid>
        <Divider sx={{ mt: 2 }} />
        <Grid container alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Enable This Section?</Typography>
          </Grid>
          <Grid item xs>
            <AntSwitch
              checked={onboardSection3Enable}
              onChange={handleOnboardSection3Enable}
              inputProps={{ 'aria-label': 'ant design' }}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={12} md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Image Upload</Typography>
          </Grid>
          <Grid item xs>
            <Box display="inline-flex" borderRadius="6px" position="relative" sx={{ boxShadow: 3 }}>
              {onboardSection3ImageSelected ?
                <Box
                  component="img"
                  src={onboardSection3ImageSelected}
                  sx={{ width: { xs: '100%', md: '350px' }, border: '3px solid white', borderRadius: '6px', mt: { xs: 1 } }}
                  alt="section3ImageSelected"
                /> :
                <Box
                  component="img"
                  src={`${config.SERVER_BASE_URL}/${onboardSection3Image}`}
                  sx={{ width: { xs: '100%', md: '350px' }, border: '3px solid white', borderRadius: '6px', mt: { xs: 1 } }}
                  alt="placeholder_image"
                />
              }
              <span className="Image-upload" onClick={handleOnboardSection3ImageUpload}>
                <i className="fa fa-pen"></i>
              </span>
              <span className="Image-remove" onClick={handleOnboardSection3ImageRemove}>
                <i className="fa fa-remove"></i>
              </span>
            </Box>
            <Typography sx={{ fontSize: '0.7rem', mt: 0.5, color: '#a1a5b7', fontWeight: 500 }}>
              Recommended size 640x360px. Allowed file types: jpg, png
            </Typography>
            <input type="file" name="idCard" id="Section3-Image-Selection" style={{ visibility: 'hidden' }} disabled={!onboardSection3Enable} onChange={handleOnboardSection3SelectImage} />
          </Grid>
        </Grid>
        <Grid container alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs={12} md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Section Heading</Typography>
          </Grid>
          <Grid item xs>
            <TextField
              variant="standard"
              fullWidth
              sx={{ mt: { xs: 1, md: 0 } }}
              value={onboardSection3Heading}
              onChange={e => setOnboardSection3Heading(e.target.value)}
              disabled={!onboardSection3Enable}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '8px 20px',
                  borderRadius: '6px',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                },
              }}
            />
          </Grid>
        </Grid>
        <Grid container alignItems="center" sx={{ mt: 2 }}>
          <Grid item xs={12} md="auto">
            <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Section Content</Typography>
          </Grid>
          <Grid item xs>
            <TextField
              variant="standard"
              fullWidth
              sx={{ mt: { xs: 1, md: 0 } }}
              multiline
              rows={8}
              value={onboardSection3Content}
              onChange={e => setOnboardSection3Content(e.target.value)}
              disabled={!onboardSection3Enable}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '15px 20px',
                  borderRadius: '6px',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                },
              }}
            />
          </Grid>
        </Grid>
      </Container>
    );
  };

  return (
    <Container maxWidth="lg">
      <Grid
        className="page-title"
        container
        justifyContent='space-between'
        sx={{ my: { sm: 2, md: 5 }, marginInline: 'auto' }}
      >
        <Grid item xs={12} sm="auto">
          <Typography sx={{ color: '#fff', fontSize: '1.5rem', fontWeight: 600 }}>Personalize Welcome Pack</Typography>
          <Typography sx={{ color: '#fff', fontSize: '0.8rem', fontWeight: 500, mt: '3px', opacity: 0.75 }}>
            Make sure your client knows his appointment etiquette inside out. Personalize a Welcome Pack sent after you approve a booking.
          </Typography>
        </Grid>
        <Grid item container direction='row' justifyContent='flex-end' alignItems="center" xs={12} sm="auto" sx={{ my: 1 }}>
          <Button color="primary" variant="contained" sx={{ fontSize: '0.8rem', fontWeight: 600, textTransform: 'none', color: '#fff', padding: '10px 30px' }} onClick={handleOpen}>Save Settings</Button>
        </Grid>
      </Grid>
      <Grid
        container
        display='flex'
        direction='row'
        alignItems="flex-start"
        spacing={2}
      >
        <Grid item container lg={8}>
          <Container
            direction='column'
            sx={{
              backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d',
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              padding: '40px !important'
            }}>
            <Grid>
              <Typography sx={{ fontWeight: 700, fontSize: '1.2rem', color: theme.palette.mode === 'light' ? '#3f4254' : '#fff' }}>Welcome Message</Typography>
              <Typography sx={{ fontSize: '11px', mt: 0.5, color: '#a1a5b7', fontWeight: 400 }}>
                This is the header of your Welcome Pack, with your personalized greetings and introductory content.
              </Typography>
            </Grid>
            <Divider sx={{ mt: 2 }} />
            <Grid container alignItems="center" sx={{ mt: 2 }}>
              <Grid item xs={12} md="auto">
                <Typography sx={{ fontSize: '0.8rem', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Welcome Heading</Typography>
              </Grid>
              <Grid item xs>
                <TextField
                  variant="standard"
                  fullWidth
                  sx={{ mt: { xs: 1 } }}
                  value={onboardHeadingTitle}
                  onChange={e => setOnboardHeadingTitle(e.target.value)}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      padding: '8px 20px',
                      borderRadius: '6px',
                      fontSize: '0.8rem',
                      fontWeight: 500,
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={12} md="auto">
                <Typography sx={{ fontSize: '0.8rem', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Welcome Message</Typography>
              </Grid>
              <Grid item xs>
                <TextField
                  variant="standard"
                  fullWidth
                  sx={{ mt: { xs: 1 } }}
                  multiline
                  rows={8}
                  value={onboardHeadingMessage}
                  onChange={e => setOnboardHeadingMessage(e.target.value)}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      padding: '15px 20px',
                      borderRadius: '6px',
                      fontSize: '0.8rem',
                      fontWeight: 500,
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" sx={{ mt: 2 }}>
              <Grid item xs md="auto">
                <Typography sx={{ fontSize: '13px', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Enable Date Details?</Typography>
              </Grid>
              <Grid item xs>
                <AntSwitch
                  checked={onboardHeadingEnableDate}
                  onChange={handleOnboardHeadingEnableDateChange}
                  inputProps={{ 'aria-label': 'ant design' }}
                />
              </Grid>
            </Grid>
          </Container>
          {renderSection1()}
          {renderSection2()}
          {renderSection3()}
          <Container
            direction='column'
            sx={{ backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', padding: '32px !important' }}
          >
            <Grid>
              <Typography sx={{ fontWeight: 700, fontSize: '1.06rem', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Footer</Typography>
              <Typography sx={{ fontSize: '11px', mt: 0.5, color: '#a1a5b7', fontWeight: 400 }}>
                Suggested content: Email or contact details for your clients to get in touch with any questions
              </Typography>
            </Grid>
            <Divider sx={{ mt: 2 }} />
            <Grid container alignItems="center" sx={{ mt: 2 }}>
              <Grid item xs={12} md="auto">
                <Typography sx={{ fontSize: '0.8rem', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Title</Typography>
              </Grid>
              <Grid item xs>
                <TextField
                  variant="standard"
                  fullWidth
                  sx={{ mt: { xs: 1 } }}
                  value={onboardFooterHeading}
                  onChange={e => setOnboardFooterHeading(e.target.value)}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      padding: '8px 20px',
                      borderRadius: '6px',
                      fontSize: '0.8rem',
                      fontWeight: 500,
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={12} md="auto">
                <Typography sx={{ fontSize: '0.8rem', fontWeight: 500, width: 200, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Message</Typography>
              </Grid>
              <Grid item xs>
                <TextField
                  variant="standard"
                  fullWidth
                  sx={{ mt: { xs: 1 } }}
                  multiline
                  rows={4}
                  value={onboardFooterContent}
                  onChange={e => setOnboardFooterContent(e.target.value)}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      padding: '15px 20px',
                      borderRadius: '6px',
                      fontSize: '0.8rem',
                      fontWeight: 500,
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Divider sx={{ mt: 2, mb: 2 }} />
            <Grid item container direction='row' justifyContent='flex-end' alignItems="center" xs="auto" sm="auto">
              <Button
                color="primary"
                variant="contained"
                sx={{
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  color: '#fff'
                }}
                onClick={handleOpen}
              >
                Save Settings
              </Button>
            </Grid>
          </Container>
        </Grid>
        <Grid
          item
          container
          lg={4}
          justifyContent='center'
          alignItems='center'
        >
          <Container
            direction='column'
            sx={{ backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d', borderRadius: 2, padding: '32px !important' }}
          >
            <Grid>
              <Typography sx={{ fontWeight: 700, fontSize: '1.2rem', lineHeight: '1.2' }}>What is the Welcome Pack?</Typography>
              <Divider sx={{ mt: 2, mb: 2 }} />
              <Typography sx={{ fontSize: '0.8rem', mt: 0.5, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>
                <p>Prior to the date, preempt any questions by sending a Welcome Pack onboarding email. Ensure your clients are aware of the important stuff beforehand, avoid wasting time on repetitive questions, and any awkwardness during the actual date.</p>
                <p>When you decide to send your Welcome Pack is at your discretion, but usually a few days before the commencement of the date.</p>
              </Typography>
            </Grid>
            <Grid sx={{ mt: 4.5, mb: 3 }}>
              <Typography sx={{ fontWeight: 700, fontSize: '1.2rem', lineHeight: '1.2' }}>Select Template</Typography>
              <Divider sx={{ mt: 2, mb: 2 }} />
              <Typography sx={{ fontSize: '0.8rem', mt: 0.5, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Customize your Welcome Pack further by selecting a styling template:</Typography>
            </Grid>
            <Stack sx={{ mt: 2, mb: 2 }}>
              <CardHeader
                classes={{ avatar: classes.avatar, title: classes.title, subheader: classes.subheader }}
                avatar={<img src={IMG_GRADIENT1} style={{ width: '40px', height: '40px', borderRadius: '25px' }} alt="gradient1" />}
                title="Classic"
                subheader="Classically dark."
                sx={{ padding: '12px', borderRadius: '12px', boxShadow: onboardTemplate === 0 ? 3 : 0 }}
                onClick={() => setOnboardTemplate(0)}
              />
              <CardHeader
                classes={{ avatar: classes.avatar, title: classes.title, subheader: classes.subheader }}
                avatar={<img src={IMG_GRADIENT2} style={{ width: '40px', height: '40px', borderRadius: '25px' }} alt="gradient2" />}
                title="Elegant"
                subheader="Sultry elegance."
                sx={{ padding: '12px', borderRadius: '12px', boxShadow: onboardTemplate === 1 ? 3 : 0 }}
                onClick={() => setOnboardTemplate(1)}
              />
              <CardHeader
                classes={{ avatar: classes.avatar, title: classes.title, subheader: classes.subheader }}
                avatar={<img src={IMG_GRADIENT3} style={{ width: '40px', height: '40px', borderRadius: '25px' }} alt="gradient3" />}
                title="Minimal"
                subheader="Beautifully light."
                sx={{ padding: '12px', borderRadius: '12px', boxShadow: onboardTemplate === 2 ? 3 : 0 }}
                onClick={() => setOnboardTemplate(2)}
              />
            </Stack>
            <SwipeableViews
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={onboardTemplate}
              onChangeIndex={setOnboardTemplate}
              // enableMouseEvents
            >
              {THUMBS.map((step, index) => (
                <div key={step.label}>
                  {Math.abs(onboardTemplate - index) <= 2 ? (
                    <Box
                      component="img"
                      sx={{
                        width: '240px',
                        display: 'block',
                        overflow: 'hidden',
                      }}
                      src={step.img}
                      alt={step.label}
                    />
                  ) : null}
                </div>
              ))}
            </SwipeableViews>
            <Grid sx={{ mt: 4.5, mb: 3 }}>
              <Typography sx={{ fontWeight: 700, fontSize: '1.2rem', lineHeight: '1.2' }}>Preview</Typography>
              <Divider sx={{ mt: 2, mb: 2 }} />
              <Typography sx={{ fontSize: '0.8rem', mt: 0.5, color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Preview your Welcome Pack to make sure everything is perfect. When you're ready, start onboarding your clients from your Bookings page!</Typography>
            </Grid>
            <Stack direction='row' sx={{ alignItems: 'center', mt: 2 }} spacing={2}>
              <Button
                variant="contained"
                onClick={onLivePreview}
                size="large"
                fullWidth
                sx={{
                  backgroundColor: '#7239ea',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  color: '#fff'
                }}
              >
                Live Preview
              </Button>
              <Button
                color="success"
                variant="contained"
                onClick={onSendToSelf}
                size="large"
                fullWidth
                sx={{
                  backgroundColor: '#7239ea',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  color: '#fff'
                }}
              >
                Send to Self
              </Button>
            </Stack>
          </Container>
        </Grid>
      </Grid>
      <ScrollToTop
        smooth
        color="#009EF7"
      />
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 360,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            padding: '48px 32px 42px',
          }}
        >
          <Grid sx={{ width: '80%', margin: 'auto' }} className="text-center">
            <Grid container justifyContent='center' alignItems='center' className="swal-question swal-close" sx={{ borderColor: "#50CD89" }}>
              <Grid className="swal-x-content" sx={{ fontSize: '3em', color: '#50CD89' }}>&#10004;</Grid>
            </Grid>
            <Typography sx={{ fontSize: '2rem', textAlign: 'center', fontWeight: 700, mt: 2, mb: 1.5 }}>
              Success!
            </Typography>
            <Typography sx={{ fontSize: '0.85rem', textAlign: 'center', fontWeight: 400 }}>
              Your settings have been saved.
            </Typography>
            <Grid item container direction='row' justifyContent='center' alignItems='center' display="flex" sx={{ mt: 3 }}>
              <Button
                color="success"
                variant="contained"
                sx={{ fontSize: '0.9rem', fontWeight: 500, textTransform: 'none', color: '#fff', padding: '12px 30px' }}
                onClick={handleClose}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={previewModalVisible}
        onClose={() => setPreviewModalVisible(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '24px',
            maxHeight: '95%',
            overflowY: 'auto',
            '::-webkit-scrollbar': {
              width: '12px',
            },
            '::-webkit-scrollbar-track': {
              backgroundColor: 'transparent',
            },
            '::-webkit-scrollbar-thumb': {
              borderRadius: '6px',
              border: '3px solid transparent',
              backgroundClip: 'content-box',
              backgroundColor: '#c1c1c1',
            }
          }}
        >
          <OnboardPreview
            onboardTemplate={emailNotification.onboardTemplate}
            onboardCompanyLogo={emailNotification.companyLogo}
            onboardHeadingTitle={onboardHeadingTitle}
            onboardHeadingMessage={onboardHeadingMessage.replace(/{client_fname}/g, user?.firstName)}
            onboardHeadingEnableDate={onboardHeadingEnableDate}
            onboardSection1Enable={onboardSection1Enable}
            onboardSection1Image={onboardSection1Image}
            onboardSection1ImageSelected={onboardSection1ImageSelected}
            onboardSection1Heading={onboardSection1Heading}
            onboardSection1Content={onboardSection1Content}
            onboardSection2Enable={onboardSection2Enable}
            onboardSection2Image={onboardSection2Image}
            onboardSection2ImageSelected={onboardSection2ImageSelected}
            onboardSection2Heading={onboardSection2Heading}
            onboardSection2Content={onboardSection2Content}
            onboardSection3Enable={onboardSection3Enable}
            onboardSection3Image={onboardSection3Image}
            onboardSection3ImageSelected={onboardSection3ImageSelected}
            onboardSection3Heading={onboardSection3Heading}
            onboardSection3Content={onboardSection3Content}
            onboardFooterHeading={onboardFooterHeading}
            onboardFooterContent={onboardFooterContent}
          />
        </Box>
      </Modal>
      <WelcomeOnboardModal
        visible={showWelcomeOnboardModal}
        onClose={onCloseWelcomeOnboardModal}
        id={user?.id}
      />
      <ConfirmModal
        visible={showConfirmModal}
        symbol="?"
        title="Save changes?"
		description="Your Welcome Pack will be updated with this content."
        titleYes="Confirm"
        titleNo="Cancel"
        onClickYes={onConfirmYes}
        onClickNo={onCloseConfirmModal}
      />
    </Container>
  );
}

export default OnboardFormPage;